import React, {Fragment, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
// import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {useOutsideClick} from "../../../misc/helperHooks";
import {FormattedMessage} from "react-intl";

const LookDropdown = (props) => {

  const {selectItems, selectedItem, selectItemClick, selectLabel, maxItems, errorsObject, changeErrorsObject, getValidationErrors,
    inputsValidated, property, size, textOnly} = props;
  const [opened, setOpened] = useState(false);
  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    setOpened(false);
  });

  const handleSelectItemClick = (selectItem, selectItemIndex) => {
    selectItemClick(selectItem, selectItemIndex);
    setOpened(false);
    checkForError();
  };

  const checkForError = () => {
    if (errorsObject && getValidationErrors && changeErrorsObject) {
      const errors = getValidationErrors(property, selectedItem.value);
      changeErrorsObject({
        [property]: errors
      })
    }
  }

  useEffect(() => {
    if (!inputsValidated) {
      checkForError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);

  const selectItemHeight = size || 36;
  const styles = {
    height: opened
      ? maxItems && (selectItems.length > maxItems)
        ? (maxItems * selectItemHeight) + "px"
        : (selectItems.length * selectItemHeight) + "px"
      : 0
  }

  const errorsExist = errorsObject && Array.isArray(errorsObject[property]) && !!errorsObject[property].length;

  return (
    <div className={"look-select " + (props.className || "")
      + (opened ? " look-select--active" : "")
      + (size ? " look-select--" + size : "")
      + (errorsExist ? " look-select--error" : "")} ref={selectElement}>
      {textOnly ? (
        <div className="look-button--full-radius look-button--no-transform look-select-value">
          <span className="look-select-value__selected">
            {selectedItem && selectedItem.preText ? <span className="look-select-value__pre-text">{selectedItem.preText}</span> : null}
            {selectLabel ? <span className="look-select-value__label">{selectLabel}</span> : null}
            {selectedItem ? selectedItem.text : "-"}
          </span>
        </div>
      ) : (
        <Button className="look-button--full-radius look-button--no-transform look-select-value"
                endIcon={<ExpandMoreIcon/>}
                onClick={() => setOpened(!opened)}>
        <span className="look-select-value__selected">
          {selectedItem && selectedItem.preText ? <span className="look-select-value__pre-text">{selectedItem.preText}</span> : null}
          {selectLabel ? <span className="look-select-value__label">{selectLabel}</span> : null}
          {selectedItem ? selectedItem.text : "-"}
        </span>
        </Button>
      )}
      {textOnly ? null : (
        <div className="look-select-dropdown" style={styles}>
          <ul className={"look-select-dropdown__list" + (maxItems ? " look-select-dropdown__list--scroll" : "")}>
            {selectItems.map((selectItem, selectItemIndex) => {
              const isSelected = selectItem.value === selectedItem.value;
              return (
                <li className="look-select-dropdown__list-item"
                    key={selectItem.text + selectItemIndex}>
                  <Button className="look-button--no-radius look-button--no-transform look-select-dropdown__button"
                          onClick={() => handleSelectItemClick(selectItem, selectItemIndex)}>
                  <span className={"look-select-value__selected" + (isSelected ? " look-select-value__selected--active" : "")}>
                    {selectItem && selectItem.preText ? (
                      <Fragment>
                        {selectItem.preText + " "}
                        <strong>{selectItem.label}</strong>
                      </Fragment>
                    ) : null}
                    {selectItem ? selectItem.text : "-"}
                  </span>
                  </Button>
                </li>
              )
            })}
          </ul>
        </div>
      )}
      {errorsExist ? (
        <div className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense">
          <FormattedMessage id={errorsObject[property][0]}/>
        </div>
      ) : ""}
    </div>
  )
};

LookDropdown.propTypes = {
  selectItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired, // intlKey
    value: PropTypes.any.isRequired,
    preText: PropTypes.string,
  })).isRequired,
  selectItemClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  selectLabel: PropTypes.string,
  className: PropTypes.string,
  maxItems: PropTypes.number,
  size: PropTypes.number,
  textOnly: PropTypes.bool,
  // validation below
  property: PropTypes.string,
  inputsValidated: PropTypes.bool,
  errorsObject: PropTypes.object, // userInfoErrorsLike
  changeErrorsObject: PropTypes.func,
  getValidationErrors: PropTypes.func,
};

export default LookDropdown
